import HappyPrompt from "./HappyPrompt";
import HappyAlert from "./HappyAlert";
import HappyComponent from "./HappyComponent";

export const HappyDialog = {
    alert: HappyAlert,
    prompt: HappyPrompt,
    customComponent: HappyComponent
}